module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-24.abc25e9a.png";